var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.657837,
    width: 35.6842,
    height: 35.6842,
    rx: 7.35,
    fill: "#2A9DF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.7914 14.21L23.6514 14.13L22.2614 13.33L19.3914 11.67C18.5114 11.16 17.1714 11.16 16.2914 11.67L13.4214 13.33L12.0314 14.14L11.8514 14.24C10.0614 15.44 9.94141 15.66 9.94141 17.59V22.2C9.94141 24.13 10.0614 24.35 11.8914 25.58L16.2914 28.12C16.7314 28.38 17.2814 28.5 17.8414 28.5C18.3914 28.5 18.9514 28.38 19.3914 28.12L23.8314 25.55C25.6214 24.35 25.7414 24.13 25.7414 22.2V17.59C25.7414 15.66 25.6214 15.44 23.7914 14.21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0322 14.14L13.4222 13.33L16.1622 11.75L16.2922 11.67C17.1722 11.16 18.5122 11.16 19.3922 11.67L19.5222 11.75L22.2622 13.33L23.6522 14.13V11.99C23.6522 9.74 22.4122 8.5 20.1622 8.5H15.5122C13.2622 8.5 12.0322 9.74 12.0322 11.99V14.14Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6815 19.84L20.0615 20.6C19.9615 20.71 19.8915 20.93 19.9015 21.08L19.9615 22.06C20.0015 22.66 19.5715 22.97 19.0115 22.75L18.1015 22.39C17.9615 22.34 17.7215 22.34 17.5815 22.39L16.6715 22.75C16.1115 22.97 15.6815 22.66 15.7215 22.06L15.7815 21.08C15.7915 20.93 15.7215 20.71 15.6215 20.6L15.0015 19.84C14.6115 19.38 14.7815 18.87 15.3615 18.72L16.3115 18.48C16.4615 18.44 16.6415 18.3 16.7215 18.17L17.2515 17.35C17.5815 16.84 18.1015 16.84 18.4315 17.35L18.9615 18.17C19.0415 18.3 19.2215 18.44 19.3715 18.48L20.3215 18.72C20.9015 18.87 21.0715 19.38 20.6815 19.84Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAward);
export default __webpack_public_path__ + "static/media/ic-award.b78035c45573d4a8052f35397b7e9d01.svg";
export { ForwardRef as ReactComponent };